import { Component, Injectable, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonContent, LoadingController, NavController, Platform } from '@ionic/angular';
import { CustomerModel } from 'src/app/models/customer-model';
import { GameVendors } from 'src/app/models/game-vendors';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { WebservicesService } from 'src/app/services/webservices/webservices.service';
import { Navigator } from "src/app/services/routing/navigator";
import { GameHistoryService } from 'src/app/services/game-history/game-history.service';
import { TimeService } from 'src/app/services/time-service/time.service';

@Component({
    selector: 'app-game-history',
    templateUrl: './game-history.component.html',
    styleUrls: ['./game-history.component.scss'],
})


@Injectable()
export class GameHistoryComponent implements OnInit {

    @ViewChild(IonContent) content: IonContent;

    emailMeDisabled: boolean = false;
    searchDisabled: boolean = false;
    showTable: boolean = false;
    showNoResults: boolean = false;
    handType: string = "none";
    gameVendors: GameVendors;
    isDetailViewed: boolean = false;

    public toDate;
    public fromDate;
    public todayDate;

    hand: any[];
    history: any[];
    totalRecords: number = 0;
    totalRecordsDetails: number = 0;
    currentHandDetails: any;
    currentPage: number = 1;
    currentPageDetails: number = 1;
    maxPage: number = 1;
    maxPageDetails: number = 1;
    currentGame;

    public startDate: any;
    public newWindow;
    public environmentName: string;
    public customer: CustomerModel;
    evoHostName;
    evoUserName;
    evoUserPassword;
    makeEvoAuthenticationURL;
    dateRange: number;

    public loading;
    constructor(
        public navCtrl: NavController,
        public gamesProvider: GameHistoryService,
        public webservices: WebservicesService,
        public userSession: UserSessionService,
        public successMessageProvider: SuccessMessageService,
        public platform: Platform,
        public config: ConfigService,
        public loadingController: LoadingController,
        private appLinks: AppLinksService,
        public alertController: AlertController,
        private navigator: Navigator,
        private timeService: TimeService) {

        this.fetchVendorList();

        this.userSession.getCustomer().subscribe(
            (customer) => {
                this.customer = customer;
            });
    }

    ngOnInit(): void {
        this.evoHostName = this.config.getConfig().FEATURE_EVOLUTION_HOSTNAME;
        this.evoUserName = this.config.getConfig().FEATURE_EVOLUTION_CASINO_KEY;
        this.evoUserPassword = this.config.getConfig().FEATURE_EVOLUTION_GM_HST_TOKEN;
        this.loading = this.loadingController.create({
            message: 'Loading...'
        });
        this.dateRange = parseInt(this.config.getConfig()["FEATURE_DATE_RANGE"]) || 14;
        //logic to pass credentials for HH Red Tiger game history link to access API endpoint without entering username/password.
        const checkEvoHostname = this.evoHostName.includes('http');
        if (checkEvoHostname) {
            const removeHttpsFromEvoHostName = this.evoHostName.slice(8);
            this.makeEvoAuthenticationURL = `https://${this.evoUserName}:${this.evoUserPassword}@${removeHttpsFromEvoHostName}`
        } else {
            this.makeEvoAuthenticationURL = this.evoHostName;
        }
    }

    calendarUpdate(event) {
        this.toDate = event.toDate;
        this.fromDate = event.fromDate;
        this.searchDisabled = event.search;
        this.successMessageProvider.clearMessage();
    }

    showLoading() {
        this.loading.then((loadingDialog) => {
            loadingDialog.present();
        });

        return setTimeout(function () { this.hideLoading(); }, 5000)
    }

    hideLoading() {
        this.loading.then((loadingDialog) => {
            loadingDialog.dismiss();
        });
    }


    fetchVendorList() {
        try {
            this.gameVendors = new GameVendors(JSON.parse(this.config.getConfig().FEATURE_HH_VENDORS));
        }
        catch {
            this.navigator.back();
        }
    }

    ionViewDidEnter() {
        this.successMessageProvider.clearMessage();

        const today = new Date();
        const date = new Date();
        this.todayDate = today;

        this.startDate = new Date(date.setDate(date.getDate() - this.dateRange)); //set start date 2 weeks ago to dynamically add 2 weeks range
        this.toDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(today)); //setting today date fallback and initial value for 'To' data passed to webservices
        this.fromDate = this.timeService.reverseDate_YYYY_MM_DD(this.timeService.formatDate_MM_DD_YYYY(date)); //'From' data passed to webservice
    }

    onSearch() {
        this.searchDisabled = true;
        this.showTable = false;
        this.currentPage = 1;

        this.getHandHistory();
    }

    onPageChange(event) {
        this.currentPage = event;

        this.getHandHistory();
    }

    onPageChangeHistory(event) {
        if(this.isDetailViewed)
        return this.onViewDetailsPala(this.currentGame, event);
        this.showDetails(this.currentGame, event);
    }

    getHandHistory() {
        this.successMessageProvider.clearMessage();

        this.gamesProvider.callCasinoGameHistory(this.fromDate, this.toDate, this.currentPage, "all").subscribe(
            (response) => {
                if (response.result == 1) {
                    this.history = response.payload.response;
                    this.totalRecords = response.payload.count;
                    this.currentPage = response.payload.current_page;
                    this.maxPage = response.payload.pages;

                    if (this.totalRecords > 0) {
                        this.showTable = true;
                        this.showNoResults = false;
                    }
                    else {
                        this.showNoResults = true;
                        this.showTable = false;
                    }
                    //TODO figure out how to scroll on ION content
                    // this.content.scrollTo(0, 335, 1000);
                }
            }
        )
    }

    sendGameHandsHistory(hand) {
        this.emailMeDisabled = true;

        const game_name = hand.gameName || "";
        const id = hand.gameId;
        const host = hand.gameHost;
        const connect = hand.connectionTime;
        const disconnect = hand.disconnectionTime;

        this.gamesProvider.sendCasinoGameDetails(id, game_name, host, connect, disconnect).subscribe({
            next: (response) => {
                if (response.result == 1) {
                    this.content.scrollToTop();
                    this.emailMeDisabled = true;
                    this.successMessageProvider.setMessage("An email with all results has been sent.");
                }
            },
            error: (error) => {
                this.emailMeDisabled = false;
                this.successMessageProvider.clearMessage();
            }
        })

    }

    showDetails(game, page = 1) {
        const convertedVendor = this.gameVendors.matchVendor(game.product);
        this.currentGame = game;
        // SPECIAL TRANSACTION-LIST-VIEW SWITCH
        // if game requires non default transaction-list-view
        // function to activate it should be added here
        switch (convertedVendor) {
            case 'PALA':
            this.showTransactionsList(game, page, convertedVendor);
                break;
            default:
                this.showTransactionsList(game, page, game.product);
                break;
        }
    }

    setUpTransactionDisplay(data, game, handType) {

        this.hand = data.payload.response;
        this.currentHandDetails = game;
        this.totalRecordsDetails = data.payload.count;
        this.currentPageDetails = data.payload.current_page;
        this.maxPageDetails = data.payload.pages;
        this.showNoResults = !(this.totalRecords > 0);
        this.handType = this.gameVendors.matchVendor(handType);

        this.content.scrollToTop();
        this.successMessageProvider.clearMessage();
    }

    onViewDetailsSelector(event) {
        switch (this.handType) {
            case "AGS":
                this.onViewDetailsAGS(event);
                break;
            case "EVERI":
                this.onViewDetailsEveri(event);
                break;
            case "SGI":
                this.onViewDetailsOGS(event);
                break;
            case "NYX":
                this.onViewDetailsOGS(event);
                break;
            case "IGT":
                this.onViewDetailsIGT(event);
                break;
            case "PLAYTECH":
                this.onViewDetailsPLAYTECH(event);
                break;
            case "SLINGO":
                this.onViewDetailsSlingo(event);
                break;
            case "EVOLUTION":
                this.onViewDetailsEvo(event);
                break;
            case "NET_ENT":
                this.onViewDetailsEnt();
                break;
            case "DGC":
                this.onViewDetailsDGC(event);
                break;
            case "ARISTOCRAT":
                this.onViewDetailsAristocrat(event);
                break;
            case "SPIN_GAMES":
                this.onViewDetailsSpinGames(event);
                break;
            case "KONAMI":
                this.onViewDetailsKonami(event);
                break
            case "PLAYNGO":
                this.onViewDetailsPLAYNGO(event);
                break;
            case "PRAGMATIC":
                this.onViewDetailsPragmatic(event);
                break;
            case "MICROGAMING":
                this.onViewDetailsMicrogaming(event);
                break;
            case "PARIPLAY":
                this.onViewDetailsPariPlay(event);
                break;
            case "BRAGG":
                this.onViewDetailsBragg(event);
                break;
            case "PALA":
                this.onViewDetailsPala(event, 1);
                break;
            default:
                console.error("Could not find correct vendor type");
                break;
        }
    }
    onViewDetailsKonami(data: any) {

        const obj = {
            'clientapp': this.config.getClientApp(),
            'round_id': data.customInfo1,
            'vendor': "konami",
            'session_token': this.userSession.getSessionToken(),
            'game_session_id': data.gameSessionId,
        }

        this.webservices.get('external/get-external-hand-history', obj).subscribe({
            next: (data: any) => {
                if (this.platform.is('capacitor')) {
                    this.gamesProvider.openIAB(data.url, "_system", "location=yes,enableviewportscale=yes");
                    return false;
                  } else {
                    this.appLinks.openExternalPage(data.url);
                    return false;
                  }
            },
            error: () => {
                this.hideLoading();
            }
        });
        return false;
    }

    // PALA =============

    onViewDetailsPala(game, page) {

        this.gamesProvider.callCasinoGameDetails(game.gameId, this.currentHandDetails.gameHost, this.currentHandDetails.connectionTime, this.currentHandDetails.disconnectionTime, page).subscribe(
            (response) => {
                if (response.result == 1) {
                    this.isDetailViewed = true;
                    const overrideDetails = {
                        id:this.currentHandDetails.id,
                        gameName: this.currentHandDetails.gameName,
                        disconnectionTime: this.currentHandDetails.disconnectionTime,
                        gameHost: this.currentHandDetails.gameHost,
                        connectionTime: this.currentHandDetails.connectionTime,
                      };
                      const mergedHandDetails = { ...game, ...overrideDetails };
                      this.setUpTransactionDisplay(response, mergedHandDetails, game.product);
                }
            }
        )
    }

    showTransactionsList(game, currentPageDetails, vendor) {
        this.successMessageProvider.clearMessage();

        const loading_timer = this.showLoading();
        this.gamesProvider.getExternalGameTransactions(game, currentPageDetails, vendor).subscribe({
            next: (response) => {
                clearTimeout(loading_timer);
                this.hideLoading();

                if (response.result == 1) {

                    this.setUpTransactionDisplay(response, game, vendor);
                }
            },
            error: () => {
                this.hideLoading();
            }
        })
    }

    //SPIN_GAMES===========

    onViewDetailsSpinGames(data) {
        const loading_timer = this.showLoading();
        const obj: any = {
            vendor: "SPINGAMES",
            game_session_id: data.gameSessionId,
            'customerid': this.customer.customerId,
            'session_token': this.userSession.getSessionToken(),
            'roundid':data.extTransId ,
            'gameid': data.extGameType
        }

        this.webservices.get('external/get-external-hand-history', obj).subscribe({
            next: (data: any) => {
                clearTimeout(loading_timer);
                this.hideLoading();
                // Open play history in a new window
                const url = data.url;
                if (this.platform.is('cordova') && (this.platform.is('ios'))) {
                    this.gamesProvider.openIAB(url, "_system", "location=yes,enableviewportscale=yes");
                    //   this.iab.create(url, "_system", "location=yes,enableviewportscale=yes");
                    return false;
                } else {
                    window.open(url, '_system');
                    return false;
                }
            },
            error: () => {
                if (!this.platform.is('cordova')) {
                    this.newWindow.close();
                }
            }
        });
    }

    // EVERI ==============
    onViewDetailsEveri(data) {

        const loading_timer = this.showLoading();

        const obj = {
            'customerId': this.customer.customerId,
            'extTransId': data.extTransId,
            'gameTypeName': data.extGameType,
            'session_token': this.userSession.getSessionToken(),
            'game_session_id': data.gameSessionId
        }
        this.webservices.get('external/get-everi-hand-history', obj).subscribe({
            next: (data: any) => {
                clearTimeout(loading_timer);
                this.hideLoading();
                // Open play history in a new window
                const url = data.url;
                if (this.platform.is('cordova') && (this.platform.is('ios'))) {
                    this.gamesProvider.openIAB(url, "_system", "location=yes,enableviewportscale=yes");
                    //   this.iab.create(url, "_system", "location=yes,enableviewportscale=yes");
                    return false;
                } else {
                    window.open(url, '_system');
                    return false;
                }
            },
            error: () => {
                this.hideLoading();
            }
        });
    }

    // AGS ================

    onViewDetailsAGS(data) {

        const obj = {
            'round_id': data.extTransId,
            'vendor': "ags",
            'session_token': this.userSession.getSessionToken(),
            'game_session_id': data.gameSessionId
        }

        this.webservices.get('external/get-external-hand-history', obj).subscribe({
            next: (data: any) => {
                if ( this.platform.is('capacitor')) {
                    this.gamesProvider.openIAB(data.url, "_system", "location=yes,enableviewportscale=yes");
                    return false;
                  } else {
                    this.appLinks.openExternalPage(data.url);
                    return false;
                  }
            },
            error: () => {
                this.hideLoading();
            }
        });
        return false;
    }

    // SGI/OGS==============

    onViewDetailsOGS(data) {
        const loading_timer = this.showLoading();

        const obj = {
            'customer_id': this.customer.customerId,
            'session_token': this.userSession.getSessionToken(),
            'round_id': data.customInfo1,
            'game_id': data.extGameType,
            'game_session_id': data.gameSessionId
        }
        this.webservices.get('external/ogs-get-round-details', obj).subscribe({
            next: (data: any) => {
                document.addEventListener('click', e => (e.target as HTMLInputElement).setAttribute('target', '_blank'));

                clearTimeout(loading_timer);
                this.hideLoading();

                this.alertController.create({
                    header: 'Transaction details',
                    message: data.html,
                    buttons: ['Close'],
                    cssClass: 'ogsDetails'
                }).then((alert) => { alert.present() });
            },
            error: () => {
                this.hideLoading();
            }
        });
        return false;
    }

    // IGT =================

    onViewDetailsIGT(data) {
        const loading_timer = this.showLoading();

        const obj = {
            'customer_id': this.customer.customerId,
            'session_token': this.userSession.getSessionToken(),
            'txnId': data.transactionSourceId,
            'game_session_id': data.gameSessionId
        }
        this.webservices.get('external/igt-get-user-game-history', obj).subscribe({
            next: (data: any) => {
                clearTimeout(loading_timer);
                this.hideLoading();
                this.alertController.create({
                    header: 'Transaction details',
                    message: data.html,
                    buttons: ['Close'],
                    cssClass: 'igtDetails'
                }).then((alert) => { alert.present() });
            },
            error: () => {
                this.hideLoading();
            }
        });
        return false;
    }

    // playngo =================

    onViewDetailsPLAYNGO(data) {
        const obj = {
            'customer_id': this.customer.customerId,
            'round_id': data.transactionSourceId,
            'vendor': "playngo",
            'session_token': this.userSession.getSessionToken(),
            'game_session_id': data.gameSessionId
        }

        this.webservices.get('external/get-external-hand-history', obj).subscribe({
            next: (data: any) => {
                if ( this.platform.is('capacitor')) {
                    this.gamesProvider.openIAB(data.url, "_system", "location=yes,enableviewportscale=yes");
                    return false;
                  } else {
                    this.appLinks.openExternalPage(data.url);
                    return false;
                  }
            },
            error: () => {
                this.hideLoading();
            }
        });
        return false;
    }

    // PlayTech =================

    onViewDetailsPLAYTECH(data) {
        const obj = {
            'round_id': data.customInfo1,
            'customer_id': this.customer.customerId,
            'vendor': "playtech",
            'game_id': data.extGameType,
            'session_token': this.userSession.getSessionToken(),
            'game_session_id': data.gameSessionId
        }
      this.webservices.get('external/get-external-hand-history', obj).subscribe({
            next: (data: any) => {
                if ( this.platform.is('capacitor')) {
                    this.gamesProvider.openIAB(data.url, "_system", "location=yes,enableviewportscale=yes");
                    return false;
                    } else {
                    this.appLinks.openExternalPage(data.url);
                    return false;
                    }
            },
            error: () => {
                this.hideLoading();
            }
        });
      return false;
    }

    // SLINGO =================

    onViewDetailsSlingo(data) {
        const loading_timer = this.showLoading();

        const obj = {
            'customer_id': this.customer.customerId,
            'game_id': data.transactionSourceId,
            'session_token': this.userSession.getSessionToken(),
            'game_session_id': data.gameSessionId
        }

        this.webservices.get('external/slingo-get-user-hand-history', obj).subscribe({
            next: (data: any) => {
                clearTimeout(loading_timer);
                this.hideLoading();
                if (this.platform.is('capacitor')) {
                    this.gamesProvider.openIAB(data.url, "_system", "location=yes,enableviewportscale=yes");
                    //   this.iab.create(url, "_system", "location=yes,enableviewportscale=yes");
                    return false;
                }else{
                this.navigator.openPopover('PopoveriFrame',
                    {
                        url: data.url,
                        title: "Slingo Game History"
                    },
                    'standard-popover game-history-details',
                    true,
                    true,
                    true,
                    -1,
                    'cover',
                    true
                );
                //   let popover = this.popoverCtrl.create(popoverView,
                //     );

                //   popover.present({ animate: true });
                return false;
                }
            },
            error: () => {
                this.hideLoading();
            }
        });
        return false;
    }


    // ARISTOCRAT ==========

    onViewDetailsAristocrat(data) {
        const loading_timer = this.showLoading();
        let dataType = "reserve";

        if(data.actionType != "reserve") {
            [data, dataType] = this.findWager(data.id);
        }

        if(dataType == "error") return;


        const obj = {
            'round_id': data.extTransId,
            'vendor': "aristocrat",
            'session_token': this.userSession.getSessionToken(),
            'game_session_id': data.gameSessionId
        }

        this.webservices.get('external/get-external-hand-history', obj).subscribe({
            next: (data: any) => {
                clearTimeout(loading_timer);
                this.hideLoading();
                const message = this.parsedDataAristocrat(data.html, dataType)
                this.alertController.create({
                    header: 'Transaction details',
                    message: message,
                    buttons: ['Close'],
                    cssClass: 'ogsDetails'
                }).then((alert) => { alert.present() });
                return false;
            },
            error: () => {
                this.hideLoading();
            }
        });
        return false;
    }

    private findWager(id) : [any, string] {
        for(let i = 0; i < this.hand.length; i++){
            if(this.hand[i].id == id) return [this.hand[--i], "resolve"];
        }
        return [{}, "error"];
    }

    private parsedDataAristocrat(data, dataType) {
        let s = "";

        if ('txnInfo' in data) {
            const round = data.txnInfo;

            const gameName = data.gameName;
            s += '<strong>Game type: </strong>' + gameName + "<br>";

            const info = round[dataType == "reserve" ? 1 : 0];
                s += '<strong> Description:  </strong>' + info.txnType + '<br>';
                s += '<strong> Payout: </strong> ' + info.gameOutcomeData.totalWin + '<br>';
                s += '<strong> Placed On: </strong> ' + info.gameRoundSpinData.createdTime + '<br>';
                s += '<strong> Stake: </strong> ' + info.gameOutcomeData.totalBet + '<br>';
                s += '<strong> TransactionId: </strong> ' + info.txnId + '<br><br>';
                s += '<strong> Reel Faces: </strong><br><br>';
            //reel faces are only displayed in wins for transaction
            round[0].gameHistoryRecord.reel_face.forEach(element => {
                element.forEach(element => {
                 s += element + ' ';
                });
                s +='<br><br>';
            });
            s += "\<br><strong> Result:  </strong><br>";
            s += info.txnType;

        }

        return s;
    }


    // EVO =================

    onViewDetailsEvo(data) {
        const loading_timer = this.showLoading();

        const obj = {
            'customer_id': this.customer.customerId,
            'session_token': this.userSession.getSessionToken(),
            'round_id': data.customInfo3,
            'game_id': data.extGameType,
            'game_session_id': data.gameSessionId
        }
        this.webservices.get('external/evi-get-game-info', obj).subscribe(
            (data: any) => {
                clearTimeout(loading_timer);
                this.hideLoading();;
                const message = this.parsedData(data.html);
            //     this.alertController.create({
            //         header: 'Transaction details',
            //         message: message,
            //         buttons: ['Close'],
            //         cssClass: 'ogsDetails'
            //     }).then((alert) => { alert.present() });
            // },
            // (error) => {
            //     this.hideLoading();;
            // }
                const d = {
                    title: "Transaction Details",
                    message:message,
                };

                this.navigator.openPopover(
                    "PopoverGameHistoryDetailsComponent",d, "standard-popover gameHistoryDetails",
                    true, true, true, -1, 'cover', true
                );
            });
        return false;
    }

    private parsedData(data) {
        let s = "";
        const getValue = (data, key) => (key in data) ? data[key] : null;

        if ('data' in data) {
            const round = data.data;

            const gameType = round.gameType;
            s += '<strong>Game type: </strong>' + gameType + "<br>";

            const participants = round.participants[0];

            s += '<strong>Bets: </strong>' + "<br>";
            const bets = getValue(participants, 'bets')
            bets.forEach(bet => {
                s += '<strong> Payout: </strong> ' + bet.payout + '<br>';
                s += '<strong> Placed On: </strong> ' + bet.placedOn + '<br>';
                s += '<strong> Stake: </strong> ' + bet.stake + '<br>';
                s += '<strong> TransactionId: </strong> ' + bet.transactionId + '<br><br>';
            });

            // let result = this.getDataString(round.result);

            // s += result;

            const hands = this.getDataString(participants.hands);
            if (hands) {
                s += "<br><strong> Hands:  </strong><br>";
                s += hands;
            }

            if(data.resultLinkHTML != undefined) {
                s += " <br> <strong> Result:  </strong><br>";
                const resultLinkHtml = decodeURIComponent(encodeURIComponent(data.resultLinkHTML));
                s+=resultLinkHtml;
            }
        }

        return s;
    }

    getDataString = (obj) => {
        const isNumber = str => /^\d+$/.test(str);
        const nameCapitalized = name => name.charAt(0).toUpperCase() + name.slice(1)

        let s = "";
        const recursify = (obj) => {
            for (const k in obj) {
                if (obj[k] instanceof Object) {
                    s += '<strong>' + nameCapitalized(k.replace(/([a-z0-9])([A-Z])/g, '$1 $2')) + '</strong> ';
                    recursify(obj[k]);
                    s += "<br>";
                } else {
                    if (!isNumber(k)) s += '<strong> ' + nameCapitalized(k.replace(/([a-z0-9])([A-Z])/g, '$1 $2')) + ' </strong> ';

                    // if(k === "link") {
                    //     let l = `<a target="_blank" href=${this.makeEvoAuthenticationURL + obj[k]}> See Details</a>`;
                    //     s+= l;
                    // }
                }
            }
        }
        recursify(obj);
        return s;
    }

    // NETENT =================

    //we do not have specific API for netEnt that will just return transactions
    //that is why we have to send users to the general list of netent transactions on external website
    onViewDetailsEnt() {
        this.userSession.getCustomer().subscribe(
            (customer) => {
                const obj: any = {
                    customer_id: customer.customerId,
                    session_token: this.userSession.getSessionToken(),
                    clientapp: this.config.getClientApp()
                }

                if (!this.platform.is('cordova')) {
                    const w: any = window;
                    this.newWindow = w.open('about:blank', '_system');
                    this.newWindow.document.write("<style> body{ background:#147b45;!important;  position: relative;} div.container { margin: 0;position: absolute;top: 50%;left: 50%;-ms-transform: translate(-50%, -50%); transform: translate(-50%, -50%);color: white;font-family: roboto;font-size: 1.5em; }</style>");
                    this.newWindow.document.write("<body><div class='container'>LOADING...</div></body>");
                }

                this.webservices.get('external/get-netent-login', obj).subscribe({
                    next: (data: any) => {
                        let token = false;
                        if (data.token) {
                            token = data.token;
                        } else if (data.payload) {
                            token = data.payload;
                        }
                        if (token) {
                            const url = `${this.config.getConfig().FEATURE_NETENT_GAMESERVER}/game/history?lang=en&sessionId=${token}`;

                            if (this.platform.is('cordova')) {
                                this.gamesProvider.openIAB(url, '', 'location=no,footer=no,hardwareback=no,hidenavigationbuttons=yes,closebuttoncaption=< back');
                                // this.newWindow = this.iab.create(url, '', 'location=no,footer=no,hardwareback=no,hidenavigationbuttons=yes,closebuttoncaption=< back');
                                this.newWindow.on('loadstop').subscribe(event => {
                                    this.newWindow.executeScript({ code: 'closeHandler = function() { window._window_has_closed=1; }' });
                                });
                                const interval = setInterval(() => {
                                    this.newWindow.executeScript({ code: "window._window_has_closed" }, val => {
                                        if (val[0]) {
                                            this.newWindow.close();
                                            clearInterval(interval);
                                        }
                                    })
                                }, 200);
                            } else {
                                this.newWindow.location = url;
                                this.newWindow.focus();
                            }
                        }
                    },
                    error: () => {
                        if (!this.platform.is('cordova')) {
                            this.newWindow.close();
                        }
                    }
                });
            }
        ).unsubscribe();
    }


    // DGC

    onViewDetailsDGC(data) {
        const loading_timer = this.showLoading();

        const obj = {
            'customer_id': this.customer.customerId,
            'round_id': data.customInfo1,
            'session_token': this.userSession.getSessionToken(),
            'game_session_id': data.gameSessionId

        }

        this.webservices.get('external/dgc-get-user-round-history', obj).subscribe({
            next: (data: any) => {
                clearTimeout(loading_timer);
                this.hideLoading();
                //   let popoverView = PopoverFactory('PopoveriFrame');
                //   let popover = this.popoverCtrl.create(popoverView, { url: data.url, title: "DGC Game History" }, {
                //       showBackdrop: true,
                //       enableBackdropDismiss: true,
                //       cssClass: 'standard-popover iframe-content full-screen'
                //   });

                //   popover.present({ animate: true });
                this.navigator.openPopover('PopoveriFrame',
                    {
                        url: data.url,
                        title: "DGC Game History"
                    },
                    'standard-popover game-history-details',
                    true,
                    true,
                    true,
                    -1,
                    'cover',
                    true
                );
                return false;
            },
            error: () => {
                this.hideLoading();
            }
        });
        return false;
    }
    ////////////////////////////

    /// PRAGMATIC

    onViewDetailsPragmatic(data) {
        const loading_timer = this.showLoading();

        const obj = {
            'customer_id': this.customer.customerId,
            'game_id': data.extGameType,
            'round_id': data.transactionSourceId,
            'session_token': this.userSession.getSessionToken(),

        }

        this.webservices.get('external/pragmatic-get-user-game-history', obj).subscribe({
            next: (data: any) => {
                clearTimeout(loading_timer);
                this.hideLoading();
                this.navigator.openPopover('PopoveriFrame',
                    {
                        url: data.html.url,
                        title: "Pragmatic Game History"
                    },
                    'standard-popover game-history-details',
                    true,
                    true,
                    true,
                    -1,
                    'cover',
                    true
                );

                // popover.present({ animate: true });
                return false;
            },
            error: () => {
                this.hideLoading();
            }
        });
        return false;
    }
    // MICROGAMING
    onViewDetailsMicrogaming(data) {
        this.alertController.create({
          cssClass: 'custom-alert',
          header: 'Game History',
          message: 'Game history is available inside the game only.',
          buttons: [
            {
              text: 'CLOSE',
              cssClass: 'alert-button-cancel',
            }
          ],
          backdropDismiss: false
        }).then(alert => alert.present());
    }
    ////////////////////////////

    // PARIPLAY
    onViewDetailsPariPlay(data) {
        const loading_timer = this.showLoading();
        const obj: any = {
            'vendor': "pariplay",
            'customer_id': this.customer.customerId,
            'session_token': this.userSession.getSessionToken(),
            'round_id':data.customInfo1 ,
            'game_id': data.extGameType
        }

        this.webservices.get('external/get-external-hand-history', obj).subscribe({
            next: (data: any) => {
                clearTimeout(loading_timer);
                this.hideLoading();
                // Open play history in a new window
                const url = data.url;
                if (this.platform.is('cordova') && (this.platform.is('ios'))) {
                    this.gamesProvider.openIAB(url, "_system", "location=yes,enableviewportscale=yes");
                    //   this.iab.create(url, "_system", "location=yes,enableviewportscale=yes");
                    return false;
                } else {
                    window.open(url, '_system');
                    return false;
                }
            },
            error: () => {
                if (!this.platform.is('cordova')) {
                    this.newWindow.close();
                }

                this.hideLoading();
            }
        });
    }
    //////////////////////////////

    //////// BRAGG
        onViewDetailsBragg(data) {
            const loading_timer = this.showLoading();
            const obj: any = {
                'vendor': "bragg",
                'customer_id': this.customer.customerId,
                'session_token': this.userSession.getSessionToken(),
                'round_id':data.customInfo1 ,
                'game_id': data.extGameType
            }
            this.webservices.get('external/get-external-hand-history', obj).subscribe({
                next: (data: any) => {

                    clearTimeout(loading_timer);
                    this.hideLoading();
                    let message = data.html.replace(/\\n/g, '\n');
                    message = message.replace(/\\r/g, '\r');
                    message = message.replace('// ', '');
                    message = message.replace('debugger', '');
                    const d = {
                        title: "Transaction Details",
                        message:message,
                    };

                    this.navigator.openPopover(
                        "PopoverStringHtmlDisplayComponent",d, "standard-popover gameHistoryDetails",
                        true, true, true, -1, 'cover', true
                    );
                },
                error: () => {
                    if (!this.platform.is('cordova')) {
                        this.newWindow.close();
                    }

                    this.hideLoading();
                }
            });
        }
    //////////////////////////////
    onPageChangeDetails(event) {
        this.currentPageDetails = event;

        this.successMessageProvider.clearMessage();
    }

    onBack = () => {
        if (this.handType != "none" || this.isDetailViewed) {
            this.handType = "none"
            this.emailMeDisabled = false;
            if(this.isDetailViewed) this.back();
        }
        else {
            this.navigator.back();
        }
    }
    back() {
        this.emailMeDisabled = false;
        this.isDetailViewed = false
        this.showDetails(this.currentGame)
    }
}
